import React from 'react'
import ProductGrid from '../components/Product/ProductGrid.jsx'
import {useParams} from "react-router-dom";

function Store() {

    let {pageURL} = useParams();
  //  console.log(pageURL);
    if(!pageURL){ pageURL = 0}

    return (
        <>
            <ProductGrid pageURL={pageURL} />
        </>
    )
}

export default Store
